exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-gops.js
// module id = 60
// module chunks = 3